import { css, unsafeCSS } from 'lit';

import token from '../../../utils/get-token';

import { defaultSwitcherProps } from './switcher.constants';

export function switcherStyles() {
	return css`
		:host {
			--m-switcher-gap: ${token(defaultSwitcherProps.gap)};
			--m-switcher-threshold: ${unsafeCSS(defaultSwitcherProps.threshold)};

			display: flex;
			flex-wrap: wrap;

			row-gap: var(--m-switcher-row-gap, var(--m-switcher-gap));
			column-gap: var(--m-switcher-column-gap, var(--m-switcher-gap));
		}

		::slotted(*) {
			flex-basis: calc((var(--m-switcher-threshold) - 100%) * 999);
			flex-grow: 1;
		}
	`;
}
